import { injectReducer } from '../../store/reducers'
import DoctorDatabase from '../DoctorDatabase'
import PatientDetail from '../PatientDetail'

export default (store) => ({
  path: 'admin',
  indexRoute: DoctorDatabase(store),
  childRoutes: [
  	PatientDetail(store)
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Home = require('./containers/HomeContainer').default;
      const reducer = require('./modules/home').default;
      injectReducer(store, { key: 'home', reducer });
      cb(null, Home);
    }, 'home')
  }
})


// WEBPACK FOOTER //
// ./src/routes/HomeAdmin/index.js